import React from "react";
import { Checkbox } from "../ui/checkbox";
import { CustomerTableRow } from "./CustomerTableRow";

export function CustomerTable({
  customers, loading,
  selected, selectableIds, allVisibleSelected,
  onToggleOne, onToggleAll, onDelete,
}) {
  return (
    <div
      className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden"
      data-testid="customers-table"
    >
      <table className="w-full">
        <thead>
          <tr className="border-b border-slate-800 text-left">
            <th className="px-3 py-3 w-10">
              <Checkbox
                checked={allVisibleSelected}
                onCheckedChange={onToggleAll}
                aria-label="Seleccionar todos los clientes visibles"
                data-testid="select-all-checkbox"
                disabled={selectableIds.length === 0}
              />
            </th>
            <th className="px-5 py-3 text-xs font-medium text-slate-400 uppercase">No. Cliente</th>
            <th className="px-5 py-3 text-xs font-medium text-slate-400 uppercase">Nombre</th>
            <th className="px-5 py-3 text-xs font-medium text-slate-400 uppercase">Tipo</th>
            <th className="px-5 py-3 text-xs font-medium text-slate-400 uppercase">RFC</th>
            <th className="px-5 py-3 text-xs font-medium text-slate-400 uppercase">KYC</th>
            <th className="px-5 py-3 text-xs font-medium text-slate-400 uppercase">Riesgo</th>
            <th className="px-5 py-3 text-xs font-medium text-slate-400 uppercase">Fecha</th>
            <th className="px-5 py-3 text-xs font-medium text-slate-400 uppercase w-12"></th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-800">
          {loading ? (
            <tr>
              <td colSpan={9} className="px-5 py-12 text-center text-slate-500">
                <div className="w-6 h-6 border-2 border-teal-400 border-t-transparent rounded-full animate-spin mx-auto" />
              </td>
            </tr>
          ) : customers.length === 0 ? (
            <tr>
              <td colSpan={9} className="px-5 py-12 text-center text-slate-500">
                No se encontraron clientes
              </td>
            </tr>
          ) : (
            customers.map((c) => (
              <CustomerTableRow
                key={c.customer_id}
                customer={c}
                isSelected={selected.has(c.customer_id)}
                onToggle={onToggleOne}
                onDelete={onDelete}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
